export default "__VITE_ASSET__DtYrh$7s__"